"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTenantPermissions = exports.fetchTenant = exports.fetchInvoices = exports.fetchBilling = exports.fetchUser = exports.fetchLink = exports.fetchThemes = exports.fetchMapThemes = exports.fetchPatternBackgrounds = exports.fetchGradientBackgrounds = exports.fetchPictureBackgrounds = exports.fetchColorBackgrounds = exports.fetchBackgrounds = exports.fetchEmojis = exports.fetchComments = exports.fetchReactions = exports.fetchWishes = exports.checkWallAvailability = exports.checkWallAddressValid = exports.validateWall = exports.unlikeWall = exports.likeWall = exports.deleteWall = exports.saveWall = exports.fetchWall = exports.jsonApiFetch = exports.apiFetch = exports.resetConfiguration = exports.configure = exports.ValidationError = exports.FieldValidationError = void 0;
/**
 * @file Main file for all exported functions and
 * objects this client implements.
 */
var api_fetch_1 = require("./api_fetch");
Object.defineProperty(exports, "apiFetch", {
  enumerable: true,
  get: function () {
    return api_fetch_1.apiFetch;
  }
});
var check_wall_address_valid_1 = __importDefault(require("./check_wall_address_valid"));
exports.checkWallAddressValid = check_wall_address_valid_1.default;
var check_wall_availability_1 = __importDefault(require("./check_wall_availability"));
exports.checkWallAvailability = check_wall_availability_1.default;
var configure_1 = require("./configure");
Object.defineProperty(exports, "configure", {
  enumerable: true,
  get: function () {
    return configure_1.configure;
  }
});
Object.defineProperty(exports, "resetConfiguration", {
  enumerable: true,
  get: function () {
    return configure_1.resetConfiguration;
  }
});
var delete_wall_1 = __importDefault(require("./delete_wall"));
exports.deleteWall = delete_wall_1.default;
var errors_1 = require("./errors");
Object.defineProperty(exports, "FieldValidationError", {
  enumerable: true,
  get: function () {
    return errors_1.FieldValidationError;
  }
});
Object.defineProperty(exports, "ValidationError", {
  enumerable: true,
  get: function () {
    return errors_1.ValidationError;
  }
});
var fetch_backgrounds_1 = __importDefault(require("./fetch_backgrounds"));
exports.fetchBackgrounds = fetch_backgrounds_1.default;
var fetch_billing_1 = __importDefault(require("./fetch_billing"));
exports.fetchBilling = fetch_billing_1.default;
var fetch_color_backgrounds_1 = __importDefault(require("./fetch_color_backgrounds"));
exports.fetchColorBackgrounds = fetch_color_backgrounds_1.default;
var fetch_comments_1 = __importDefault(require("./fetch_comments"));
exports.fetchComments = fetch_comments_1.default;
var fetch_emojis_1 = __importDefault(require("./fetch_emojis"));
exports.fetchEmojis = fetch_emojis_1.default;
var fetch_gradient_backgrounds_1 = __importDefault(require("./fetch_gradient_backgrounds"));
exports.fetchGradientBackgrounds = fetch_gradient_backgrounds_1.default;
var fetch_invoices_1 = __importDefault(require("./fetch_invoices"));
exports.fetchInvoices = fetch_invoices_1.default;
var fetch_link_1 = __importDefault(require("./fetch_link"));
exports.fetchLink = fetch_link_1.default;
var fetch_map_themes_1 = __importDefault(require("./fetch_map_themes"));
exports.fetchMapThemes = fetch_map_themes_1.default;
var fetch_pattern_backgrounds_1 = __importDefault(require("./fetch_pattern_backgrounds"));
exports.fetchPatternBackgrounds = fetch_pattern_backgrounds_1.default;
var fetch_picture_backgrounds_1 = __importDefault(require("./fetch_picture_backgrounds"));
exports.fetchPictureBackgrounds = fetch_picture_backgrounds_1.default;
var fetch_reactions_1 = __importDefault(require("./fetch_reactions"));
exports.fetchReactions = fetch_reactions_1.default;
var fetch_tenant_1 = __importDefault(require("./fetch_tenant"));
exports.fetchTenant = fetch_tenant_1.default;
var fetch_tenant_permissions_1 = __importDefault(require("./fetch_tenant_permissions"));
exports.fetchTenantPermissions = fetch_tenant_permissions_1.default;
var fetch_themes_1 = __importDefault(require("./fetch_themes"));
exports.fetchThemes = fetch_themes_1.default;
var fetch_user_1 = __importDefault(require("./fetch_user"));
exports.fetchUser = fetch_user_1.default;
var fetch_wall_1 = __importDefault(require("./fetch_wall"));
exports.fetchWall = fetch_wall_1.default;
var fetch_wishes_1 = __importDefault(require("./fetch_wishes"));
exports.fetchWishes = fetch_wishes_1.default;
var json_api_fetch_1 = require("./json_api_fetch");
Object.defineProperty(exports, "jsonApiFetch", {
  enumerable: true,
  get: function () {
    return json_api_fetch_1.jsonApiFetch;
  }
});
var like_wall_1 = __importDefault(require("./like_wall"));
exports.likeWall = like_wall_1.default;
var save_wall_1 = __importDefault(require("./save_wall"));
exports.saveWall = save_wall_1.default;
var unlike_wall_1 = __importDefault(require("./unlike_wall"));
exports.unlikeWall = unlike_wall_1.default;
var validate_wall_1 = __importDefault(require("./validate_wall"));
exports.validateWall = validate_wall_1.default;
/****************
 * EXPORT
 ****************/
// Enums
__exportStar(require("./enums"), exports);
// Types
// From the store module
__exportStar(require("./store"), exports);